import Config from '~domain/entities/Config/Config';
import { diContainer } from '~setup/diContainer';
import { serviceNames } from '~setup/CartService';
import { fetchByCategory } from '~api/DonationsAPI/FetchByCategory';
import { fetchBySkus } from '~api/DonationsAPI/FetchBySkus';
import { fetchByProducts } from '~api/DonationsAPI/FetchByProducts';

import { IDonation } from '~domain/entities/Donation/IDonation';

const emptyDefault = { ids: [''], description: '' };
const hasIds = (ids: string[]) => ids[0] !== emptyDefault.ids[0];

export const fetchDonations = () => {
    const { config }: Config = diContainer.get(serviceNames.config);
    const {
        products = emptyDefault,
        skus = emptyDefault,
        categories = emptyDefault
    } = config?.cartConfig?.donationsConfigs || {
        products: emptyDefault,
        skus: emptyDefault,
        categories: emptyDefault
    };

    const categoryDonations = hasIds(categories.ids) ? fetchByCategory(categories) : null;
    const skusDonations = hasIds(skus.ids) ? fetchBySkus(skus) : null;
    const productsDonations = hasIds(products.ids) ? fetchByProducts(products) : null;

    return Promise.all([categoryDonations, skusDonations, productsDonations]).then(
        (res) => res.filter((elem) => !!elem) as IDonation[]
    );
};
